import Analytics from '../../assets/icons/trvto_analytics.svg';
import Bookings from '../../assets/icons/trvto_bookings.svg';
import Dashboard from '../../assets/icons/trvto_dashboard.svg';
import Insights from '../../assets/icons/trvto_insights.svg';
import MyRooms from '../../assets/icons/trvto_my_rooms.svg';
import Reviews from '../../assets/icons/trvto_reviews.svg';
import Tickets from '../../assets/icons/trvto_tickets.svg';
import Payments from '../../assets/icons/trvto_payments.svg';
import Promotions from '../../assets/icons/trvto_promotions.svg';
import User from '../../assets/icons/trvto_userManagement.svg';
import CustomerSupport from '../../assets/icons/trvto_contact.svg';
import DashboardActive from '../../assets/icons/trvto_dashboardActive.svg';
import AnalyticsActive from '../../assets/icons/trvto_analyticsActive.svg';
import MyRoomsActive from '../../assets/icons/trvto_myRoomsActive.svg';
import ReviewActive from '../../assets/icons/trvto_ReviewActive.svg';
import BookingActive from '../../assets/icons/trvto_BookingActive.svg';
import InsightsActive from '../../assets/icons/trvto_insightsActive.svg';
import CustomerSupportActive from '../../assets/icons/trvto_custSupportActive.svg';
import TicketsActive from '../../assets/icons/trvto_ticketsActive.svg';
import PaymentsActive from '../../assets/icons/trvto_paymentsActive.svg';
import PromotionsActive from '../../assets/icons/trvto_promotionsActive.svg';
import UserActive from '../../assets/icons/trvto_supUserActive.svg';
import DownArrow from '../../assets/icons/trvto_down-arrow-white.svg';
import SuperAdmin from '../../assets/icons/trvto_superAdmin.svg';
import AbondonBookings from '../../assets/icons/abondon-bookings.svg';
import AbondonBookingsActive from '../../assets/icons/abondon-bookings-active.svg';
import Message from '../../assets/icons/trvto_message.svg';
import MessageActive from '../../assets/icons/trvto_messageActive.svg';
import Search from '../../assets/icons/trvto_searchIcon.svg';
import SearchActive from '../../assets/icons/trvto_searchIconActive.svg';
import Notification from '../../assets/icons/trvto_notification.svg';
import NotificationActive from '../../assets/icons/trvto_notificationActive.svg';

export const getLeftMenuData = (mode = 't') => {
    const packageLabelMap = {
        a: 'Activity',
        c: 'Camp',
        g: 'Guide',
        t: 'Packages'
    };
    const packageTitle = packageLabelMap[mode] || 'Packages';
    return [
        {
            title: 'Admin',
            path: '#',
            icon: SuperAdmin,
            activeIcon: DownArrow,

            children: [
                {
                    title: 'Dashboard',
                    path: `/support/${mode}/dashboard`,
                    icon: Dashboard,
                    activeIcon: DashboardActive
                },
                {
                    title: packageTitle,
                    path: `/support/${mode}/packages`,
                    icon: MyRooms,
                    activeIcon: MyRoomsActive
                },
                {
                    title: 'Bookings',
                    path: `/support/${mode}/bookings`,
                    icon: Bookings,
                    activeIcon: BookingActive
                },
                {
                    title: 'Billings',
                    path: `/support/${mode}/billings`,
                    icon: Payments,
                    activeIcon: PaymentsActive
                },
                {
                    title: 'Accounts',
                    path: `/support/${mode}/org/account`,
                    icon: User,
                    activeIcon: UserActive
                }
            ]
        },
        {
            title: 'Tickets',
            path: '/support/admin/tickets',
            icon: Tickets,
            activeIcon: TicketsActive
        },
        {
            title: 'ChatBot',
            path: '/support/admin/chatbot',
            icon: Message,
            activeIcon: MessageActive
        },
        // {
        //     title: 'Staff Calls',
        //     path: '/support/admin/staff-calls',
        //     icon: Message,
        //     activeIcon: MessageActive
        // },
        {
            title: 'App',
            path: '#',
            icon: SuperAdmin,
            activeIcon: DownArrow,

            children: [
                {
                    title: 'Notifications',
                    path: '/support/admin/app-notification',
                    icon: Notification,
                    activeIcon: NotificationActive
                },
                {
                    title: 'Version',
                    path: `/support/admin/app-versions`,
                    icon: MyRooms,
                    activeIcon: MyRoomsActive
                }
            ]
        },
        {
            title: 'Blogs',
            path: '/support/admin/blogs',
            icon: MyRooms,
            activeIcon: MyRoomsActive
        },
        {
            title: 'Offers',
            path: '/support/admin/offers',
            icon: Bookings,
            activeIcon: BookingActive
        },
        {
            title: 'Dropdowns/Filters',
            path: '/support/admin/dropdowns',
            icon: Dashboard,
            activeIcon: DashboardActive
        },
        {
            title: 'Search Keywords',
            path: '/support/admin/search-keywords',
            icon: Search,
            activeIcon: SearchActive
        },
        {
            title: 'Payments',
            path: '/support/admin/payments',
            icon: Payments,
            activeIcon: PaymentsActive
        },
        {
            // sales, commission, GST, TDS, payouts & bills, CA Excel (pages/supFinance)
            title: 'Finance',
            path: '/support/admin/finance',
            icon: Insights,
            activeIcon: InsightsActive
        },
        {
            title: 'Approvals',
            path: '/support/admin/approvals',
            icon: Reviews,
            activeIcon: ReviewActive
        },
        {
            title: 'Abondon',
            path: '/support/admin/abandon',
            icon: AbondonBookingsActive,
            activeIcon: AbondonBookings
        },
        {
            title: 'Promotions',
            path: '#',
            icon: Promotions,
            activeIcon: PromotionsActive
        },
        {
            title: 'User Management',
            path: '#',
            icon: User,
            activeIcon: UserActive
        },
        {
            title: 'Customer Support',
            path: '/support/admin/customer-support',
            icon: CustomerSupport,
            activeIcon: CustomerSupportActive
        },
        {
            title: 'Reporting',
            path: '#',
            icon: Insights,
            activeIcon: InsightsActive
        },
        {
            title: 'Analytics',
            path: '/support/admin/analytics',
            icon: Analytics,
            activeIcon: AnalyticsActive
        },
        {
            title: 'FAQ',
            path: '/support/admin/faq',
            icon: Reviews,
            activeIcon: ReviewActive
        },
        {
            title: 'Reviews',
            path: '#',
            icon: Reviews,
            activeIcon: ReviewActive
        }
    ];
};
